import { memo } from 'react'

import TtsVelocityOptions from '../Components/Options'

interface IProps {
  selectedValue: number | string
  handleValueClick: (value: number) => void
}

import * as Styled from './styled'

const TtsVelocityContent: React.FC<IProps> = (props: IProps) => {
  const { selectedValue, handleValueClick } = props

  return (
    <Styled.TtsVelocityContentWrapper>
      <TtsVelocityOptions
        selectedValue={selectedValue}
        handleValueClick={handleValueClick}
      />
    </Styled.TtsVelocityContentWrapper>
  )
}

export default memo(TtsVelocityContent)
